import { useContext } from "react";
import { AuthContext  ,services } from "../util/api";
import  "../value.css";

export default function Values() {
  const { theme } = useContext(AuthContext);



  return (
    <div className={theme}>
      <section className="values reveal" id="about">
        <div className="values-container">
          <header className="values-header">
            <h2>Our Services</h2>
            <p>We deliver reliable, innovative, and tailored solutions designed to meet your unique needs and drive measurable results.</p>
          </header>

          <div className="values-grid">
            {services.map((service, index) => (
              <article className={`value-card ${index === 0 ? "featured" : ""}`} key={index}>
                <div className="value-icon">{service.icon}</div>
                <h3>{service.title}</h3>
                <p>{service.desc}</p>
                <a href={service.link} className="btn-secondary">
                  Explore Platform
                </a>
              </article>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}